export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13587.e04966b2.jpg";